'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFormFieldError = require('./CwFormFieldError.scss');

var _CwFormFieldError2 = _interopRequireDefault(_CwFormFieldError);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CwLabel = require('../../components/cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFormFieldError = function CwFormFieldError(props) {
  return _react2.default.createElement(_CwLabel2.default, {
    cwId: props.cwId,
    className: (0, _classnames2.default)(props.className, _CwFormFieldError2.default.error),
    style: props.style,
    value: props.error
  });
};

CwFormFieldError.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * The error label for form field. Will display if set
   */
  error: _propTypes2.default.string
};

exports.default = CwFormFieldError;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwformfield/CwFormFieldError.js
// module id = 371
// module chunks = 10